export default __webpack_public_path__ + "static/media/sensor-value.f1f89486.svg";